import { render, staticRenderFns } from "./money.vue?vue&type=template&id=074dd822&scoped=true&"
import script from "./money.vue?vue&type=script&lang=ts&"
export * from "./money.vue?vue&type=script&lang=ts&"
import style0 from "./money.vue?vue&type=style&index=0&id=074dd822&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074dd822",
  null
  
)

export default component.exports